import { EmptyPO } from "asset/icons";
import { formatDate } from "component/flex/utils";
import React from "react";

const PurchaseOrderTab = ({ orders }) => {
    let totalOrders = orders?.length ? [...orders] : [];
    return (
        <>
            {totalOrders?.length > 0 ? (
                <>
                    {totalOrders?.map((order, index) => (
                        <div
                            key={index}
                            className="flex items-center justify-between py-3 border-b last:border-b-0"
                        >
                            <div>
                                <p className="font-semibold text-gray-800">
                                {order?.title}
                                </p>
                                <div className="flex items-center gap-x-2">
                                    <p className="text-sm font-medium text-green-600">
                                        {order?.orderStatus}
                                    </p>
                                    •
                                    <p className="text-sm text-gray-500">
                                        {formatDate(order?.createdAt)}
                                    </p>
                                </div>
                            </div>
                            <div className="text-right">
                                <p className="text-lg font-semibold text-gray-900">
                                    ₦ {order?.totalAmount?.toLocaleString()}
                                </p>
                                <p className="text-sm text-gray-500">
                                    {order?.orderItems?.length} Items
                                </p>
                            </div>
                        </div>
                    ))}
                </>
            ) : (
                <div className="grid justify-center py-20">
                    <div className="pl-10 !mb-5">
                        <EmptyPO />
                    </div>
                    <p className="text-gray-500">No purchase orders here.</p>
                </div>
            )}
        </>
    );
};

export default PurchaseOrderTab;
